import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import LandingPage from './LandingPage';
import { ManagePreferences } from './ManagePreferences/ManagePreferences';
import { initializeAnalytics } from '@mental-mint/shared-utils';
import { ErrorBoundary } from '@mental-mint/shared-ui';
import { store } from './store';
import './index.css';

initializeAnalytics('landing');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Simple router without react-router-dom dependency
const App = () => {
  const path = window.location.pathname;
  
  if (path === '/manage-preferences') {
    return <ManagePreferences />;
  }
  
  return <LandingPage />;
};

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <App />
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);
